import {
	adminPressKitById,
	adminPressKitCreate,
	adminPressKitDestroy,
	adminPressKitList,
	adminPressKitPreviewUrl,
	adminPressKitUpdateStatus,
	adminPressKitUpdateTheme,
	adminPressKitSendInsightsEmail,
} from '@/services/agency/press-kits.admin.service'

export default {
	namespaced: true,
	state: {
		pressKitList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		pressKit: {},
		listStatus: 'init',
		saveStatus: 'init',
		deleteStatus: 'init',
	},
	getters: {
		getPressKitList(state) {
			return state.pressKitList
		},
		getPressKit(state) {
			return state.pressKit
		},
		// Aliased names used by the list/detail views
		getPressKitListStatus(state) {
			return state.listStatus
		},
		getPressKitSaveStatus(state) {
			return state.saveStatus
		},
		getPressKitDeleteStatus(state) {
			return state.deleteStatus
		},
		// Legacy names kept for backward compat
		getListStatus(state) {
			return state.listStatus
		},
		getSaveStatus(state) {
			return state.saveStatus
		},
		getDeleteStatus(state) {
			return state.deleteStatus
		},
	},
	mutations: {
		PRESS_KIT_LIST(state, value) {
			state.pressKitList = value
		},
		PRESS_KIT(state, value) {
			state.pressKit = value
		},
		PRESS_KIT_LIST_STATUS(state, value) {
			state.listStatus = value
		},
		PRESS_KIT_SAVE_STATUS(state, value) {
			state.saveStatus = value
		},
		PRESS_KIT_DELETE_STATUS(state, value) {
			state.deleteStatus = value
		},
	},
	actions: {
		async fetchPressKitList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('PRESS_KIT_LIST_STATUS', 'pending')
			commit('PRESS_KIT_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await adminPressKitList(params)
				commit('PRESS_KIT_LIST_STATUS', 'init')
				commit('PRESS_KIT_LIST', data)
				return data
			} catch (error) {
				commit('PRESS_KIT_LIST_STATUS', 'init')
				throw error
			}
		},
		async fetchPressKit({ commit }, id) {
			commit('PRESS_KIT_LIST_STATUS', 'pending')
			try {
				const { data } = await adminPressKitById(id)
				commit('PRESS_KIT_LIST_STATUS', 'init')
				commit('PRESS_KIT', data.data)
				return data
			} catch (error) {
				commit('PRESS_KIT_LIST_STATUS', 'init')
				return error
			}
		},
		async createPressKit({ commit }, params) {
			commit('PRESS_KIT_SAVE_STATUS', 'pending')
			try {
				const { data } = await adminPressKitCreate(params)
				commit('PRESS_KIT_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('PRESS_KIT_SAVE_STATUS', 'error')
				throw error
			}
		},
		async updatePressKitStatus({ commit }, { id, status }) {
			commit('PRESS_KIT_SAVE_STATUS', 'pending')
			try {
				const { data } = await adminPressKitUpdateStatus(id, status)
				commit('PRESS_KIT_SAVE_STATUS', 'init')
				if (data?.data) commit('PRESS_KIT', data.data)
				return data
			} catch (error) {
				commit('PRESS_KIT_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updatePressKitTheme({ commit }, { id, theme }) {
			commit('PRESS_KIT_SAVE_STATUS', 'pending')
			try {
				const { data } = await adminPressKitUpdateTheme(id, theme)
				commit('PRESS_KIT_SAVE_STATUS', 'init')
				if (data?.data) commit('PRESS_KIT', data.data)
				return data
			} catch (error) {
				commit('PRESS_KIT_SAVE_STATUS', 'init')
				throw error
			}
		},
		async fetchPressKitPreviewUrl(_, id) {
			const { data } = await adminPressKitPreviewUrl(id)
			return data?.data?.url
		},
		async sendPressKitInsightsEmail(_, id) {
			const { data } = await adminPressKitSendInsightsEmail(id)
			return data
		},
		async deletePressKit({ commit }, id) {
			commit('PRESS_KIT_DELETE_STATUS', 'pending')
			try {
				const { data } = await adminPressKitDestroy(id)
				commit('PRESS_KIT_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('PRESS_KIT_DELETE_STATUS', 'error')
				return error
			}
		},
	},
}
